// extracted by mini-css-extract-plugin
export default {"ingredients__item":"burger-ingredient_ingredients__item__ZBY2o","contain":"burger-ingredient_contain__Gw3-2","ingredients__link":"burger-ingredient_ingredients__link__OKZ3R"};